import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';
import type { TableProps } from 'antd';
import React from 'react';
import type { LeaderboardRow } from './hooks/useLeaderboard';

type ExpandIconProps = Parameters<
  NonNullable<
    NonNullable<TableProps<LeaderboardRow>['expandable']>['expandIcon']
  >
>[0];

const ExpandIcon = function ({ expanded, onExpand, record }: ExpandIconProps) {
  if (!('node' in record)) {
    return null;
  }

  const IconNode = expanded ? CaretUpFilled : CaretDownFilled;
  return (
    <IconNode
      style={{ fontSize: 18, padding: '20px 10px' }}
      onClick={(e) => {
        e.stopPropagation();
        onExpand(record, e);
      }}
    />
  );
};

export default ExpandIcon;
